import axios from '../../utils/axios'
import { API_BASE_URL } from '../../constants'

/**
 * Get comprehensive files dashboard data
 * @param {number} days - Number of days to look back (default: 30)
 * @param {Object} opts - Optional options
 * @param {boolean} opts.refresh - If true, bypass backend cache
 * @returns {Promise<Object>} Dashboard data including file statistics, trends, and metrics
 */
export const getFilesDashboardData = async (days = 30, opts = {}) => {
  const { refresh = false } = opts
  try {
    const refreshParam = refresh ? '&refresh=1' : ''
    const response = await axios.get(`${API_BASE_URL}/files-dashboard/?days=${days}${refreshParam}`)
    return response.data
  } catch (error) {
    console.error('Error fetching files dashboard data:', error)
    throw error
  }
}

/**
 * Get file type distribution data
 * @param {number} days - Number of days to look back
 * @returns {Promise<Object>} File type distribution statistics
 */
export const getFileTypeDistribution = async (days = 30) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/files-dashboard/?days=${days}`)
    return response.data.file_type_distribution
  } catch (error) {
    console.error('Error fetching file type distribution:', error)
    throw error
  }
}

/**
 * Get upload trends data
 * @param {number} days - Number of days to look back
 * @returns {Promise<Object>} Upload trends and statistics
 */
export const getUploadTrends = async (days = 30) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/files-dashboard/?days=${days}`)
    return response.data.upload_trends
  } catch (error) {
    console.error('Error fetching upload trends:', error)
    throw error
  }
}

/**
 * Get recent uploads
 * @returns {Promise<Array>} Recent file uploads
 */
export const getRecentUploads = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/files-dashboard/`)
    return response.data.recent_uploads
  } catch (error) {
    console.error('Error fetching recent uploads:', error)
    throw error
  }
}

/**
 * Get analysis status distribution
 * @returns {Promise<Object>} Analysis completion statistics
 */
export const getAnalysisStatus = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/files-dashboard/`)
    return response.data.analysis_status
  } catch (error) {
    console.error('Error fetching analysis status:', error)
    throw error
  }
}

/**
 * Get organization statistics
 * @returns {Promise<Object>} Organization-level file and user statistics
 */
export const getOrganizationStats = async () => {
  try {
    const response = await axios.get(`${API_BASE_URL}/files-dashboard/`)
    return response.data.organization_stats
  } catch (error) {
    console.error('Error fetching organization stats:', error)
    throw error
  }
}
